export const APP_SHOW_MODAL_ERRORS = 'APP_SHOW_MODAL_ERRORS';
export const APP_CLEAR_MODAL_ERRORS = 'APP_CLEAR_MODAL_ERRORS';
export const NOOP = 'NOOP';
export const LOADED = 'LOADED';
